









































































































import { EnvironmentMixin } from "@/helpers/environment-mixin";
import { Component, Mixins } from "vue-property-decorator";
import AppHeader from "./AppHeader.vue";
import NotFound from "./NotFound.vue";

@Component({
  components: {
    AppHeader,
    NotFound
  }
})
export default class AdminPage extends Mixins<EnvironmentMixin>() {
  get service() {
    return this.$store.state.service;
  }

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  get assignedProjects() {
    return this.$store.state.assignedProjects;
  }

  canReadMaster() {
    return (
      this.permissions.includes("service/master_read") || this.assignedProjects
    );
  }
}
